<template>
  <article>
    <h1 class="hidden">{{ t('meta.title') }}</h1>
    <LoaderStack v-if="isLoading" />
    <template v-else>
      <AreaHomeBanners />
      <LazyAreaHomeAdlinks />
      <template v-if="!isCN">
        <LazyAreaHomeOverview />
        <LazyAreaHomeListIcon />
        <LazyAreaHomeHighlight />
      </template>
      <LazyAreaHomeSolutions />
      <LazyAreaHomeProducts />
      <LazyAreaHomeStories />
      <LazyAreaHomePartnership />
      <LazyAreaHomeContactUs />
    </template>
  </article>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const { isCN } = useLanguage();
  const homeStore = useHomeStore();
  const { banners } = storeToRefs(homeStore);

  const { status: GET_BANNERS_STATUS } = await homeStore.USE_GET_BANNERS();
  const { status: GET_DOMAIN_PRODUCTS_STATUS } =
    await homeStore.USE_GET_HOME_CATEGORY();

  const isLoading = computed(
    (): boolean =>
      GET_BANNERS_STATUS.value === 'pending' ||
      GET_DOMAIN_PRODUCTS_STATUS.value === 'pending'
  );

  // Preload first banner background image for better LCP

  useHead(() => ({
    link: [
      {
        rel: 'preload',
        as: 'image',
        type: 'image/webp',
        fetchpriority: 'high',
        imagesrcset: banners.value[0]?.webBackgroundImage || '',
        imagesizes: '(min-width: 1025px) 1920px',
      },
    ],
  }));
</script>
